module.exports = require("moment-timezone");


/*****************
 ** WEBPACK FOOTER
 ** external "moment-timezone"
 ** module id = 21
 ** module chunks = 0
 **/